import React, { createContext, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api';

const TenantContext = createContext(null);

export function TenantProvider({ children }) {
  const { tenantSlug } = useParams();
  const [branding, setBranding] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!tenantSlug) { setLoading(false); return; }
    setLoading(true);
    api.get(`/tenants/${tenantSlug}/branding`)
      .then((res) => {
        const b = res.data;
        setBranding(b);
        applyBranding(b);
      })
      .catch((err) => {
        setError(err.response?.data?.detail || 'Agência não encontrada');
      })
      .finally(() => setLoading(false));
  }, [tenantSlug]);

  return (
    <TenantContext.Provider value={{ branding, loading, error, tenantSlug }}>
      {children}
    </TenantContext.Provider>
  );
}

function applyBranding(b) {
  const root = document.documentElement;
  if (b.corPrimaria) root.style.setProperty('--brand-primary', b.corPrimaria);
  if (b.corSecundaria) root.style.setProperty('--brand-secondary', b.corSecundaria);
  if (b.corSidebar) root.style.setProperty('--brand-sidebar', b.corSidebar);
  if (b.nomeDoSistema) document.title = b.nomeDoSistema;
}

export function useTenant() {
  return useContext(TenantContext);
}
